<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      color="primary"
      dark
    >
      <div class="pa-5 title-block">
        <h1 class="sidebar-title">Pacific</h1>
        <p>Electical Installations</p>
      </div>
      <v-divider></v-divider>
      <v-list dense flat>
        <div v-if="this.userRole === 'Worker' || this.userRole === 'Sub Foreman'">
          <v-list-item v-for="(menu, index) in subForemanMenuItems" :key="index" :to="menu.url">
            <v-list-item-action>
            <v-icon>{{ menu.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ menu.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </div>
        <div v-else>
          <v-list-item v-for="(menu, index) in menuItems" :key="index" :to="menu.url">
            <v-list-item-action>
            <v-icon>{{ menu.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ menu.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </div>

        <div v-if="this.userRole === 'Admin'">
          <v-list-group
            v-for="item in managementItems"
            :key="item.name"
            v-model="item.active"
            :prepend-icon="item.icon"
            no-action
            color="menuSelectedColour"
            active-class="blank"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="subItem in item.items"
              :key="subItem.name"
              :to="subItem.url"
            >
              <v-list-item-content>
                <v-list-item-title v-text="subItem.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon>logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Logout
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      dark
      elevation="0"
      color="primary"
      v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs || $vuetify.breakpoint.md"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>PEI</v-toolbar-title>
    </v-app-bar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data: () => ({
    drawer: true,
    subForemanMenuItems: [
      { icon: 'calendar_today', name: 'Schedule', url: '/calendar' },
      { icon: 'assignment', name: 'Work Orders', url: '/work-orders' }
    ],
    menuItems: [
      { icon: 'assignment', name: 'Work Orders', url: '/work-orders' },
      { icon: 'calendar_today', name: 'Schedule', url: '/calendar' },
      { icon: 'mdi-folder-open', name: 'Documents', url: '/documents' }
    ],
    managementItems: [
      {
        icon: 'settings',
        name: 'Management',
        url: '',
        items: [
          { name: 'Crews', url: '/management/crews' },
          { name: 'Staff', url: '/management/users' },
          { name: 'Document Types', url: '/management/document-types' }
        ]
      }
    ]
  }),
  methods: {
    ...mapActions({
      logout: 'auth/logout'
    })
  },
  computed: {
    ...mapGetters({
      userRole: 'user/role'
    })
  }
}
</script>
<style scoped>
  .blank {
    color: white !important;
  }
  .v-list-item {
    color: #1976d2;
  }
</style>
